/**
 * Drawer Mode Enum
 *
 * Discriminates the shared layout drawer's two sizes. Uses singleton pattern for instance
 * management.
 *
 * @module layout/enums/drawerMode
 */

export default class DrawerMode {
  static instances = {};

  /** Drawer takes roughly the lower portion of the screen. */
  static get Partial() {
    return this.getInstance('partial');
  }

  /** Drawer covers the entire screen. */
  static get Full() {
    return this.getInstance('full');
  }

  /** Drawer is hidden from view. */
  static get Hidden() {
    return this.getInstance('hidden');
  }

  /** @private */
  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new DrawerMode(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return this.name;
  }
}
